// @flow
import { normalize } from 'normalizr'
import typeToReducer from 'type-to-reducer'

import { isValidTTL, calculateExpires } from '@alphaott/app-main/selectors'
import countriesListSchema from '@alphaott/common-utils/utils/schemas/countries'

import type { Country } from '@alphaott/api-client/types/countries'

import { FETCH_RADIO_CHANNEL_COUNTRIES } from '../../actions/radioChannelCountries'

export type RadioChannelCountriesState = {
  +isLoading: boolean,
  +isSuccess: boolean,
  +isError: boolean,
  +errors: any,
  +data: Array<Country>,
  +result: Array<string>,
  +expires: ?number,
}

const initialState: RadioChannelCountriesState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errors: [],
  data: [],
  result: [],
  expires: null,
}

const radioChannelCountries = typeToReducer(
  {
    [FETCH_RADIO_CHANNEL_COUNTRIES]: {
      LOADING: (state): RadioChannelCountriesState => ({ ...state, isLoading: true }),

      SUCCESS: (state, action): RadioChannelCountriesState => {
        const {
          meta: { ttl },
        } = action
        const { result } = normalize(action.payload.data, countriesListSchema)
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          data: action.payload.data,
          result,
          ...(isValidTTL(ttl) && { expires: calculateExpires(ttl) }),
        }
      },

      ERROR: (state, action): RadioChannelCountriesState => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        errors: action.payload.error,
        expires: null,
      }),
    },
  },
  initialState,
)

export { radioChannelCountries }
